import React from 'react';
import styles from './PlayerComment.module.scss';
import { useTranslation } from 'react-i18next';
import MiniUserDetail from '../MiniUserDetail/MiniUserDetail';
import { parseString } from '../../utils/stringHelper';
import Icon from '../Icon/Icon';
import { CustomButton } from '../Button/Button';

const HoverPlayerContent = ({ comment, sameTimestampComments = null, showGoToComment = false, commentStyles = {}, maxHeight, onClick }) => {

    const { t } = useTranslation();

    return <div className={styles.commentContainerWrapper} style={commentStyles}>
        <div className={styles.commentContainer} style={{ maxHeight: `${maxHeight}px` }}>
            <MiniUserDetail
                avatar={comment?.authorAvatar}
                size="medium"
                oneLetterAcronym={false}
                name={parseString(comment?.authorName)}
                classNames={{
                    titleClassName: styles.avatarTitle,
                    containerClassName: styles.avatarContainer
                }}
            />
            <div className={styles.textContainer}>
                <span className={styles.author}>{comment?.authorName}</span>
                <span className={styles.text}>{comment?.text}</span>
                {sameTimestampComments && sameTimestampComments > 1 && (
                    <span className={styles.extraComments}>+{sameTimestampComments - 1} {sameTimestampComments > 2 ? t('my_video.general.comments') : t('general.comment')}</span>
                )}
            </div>
            {showGoToComment && <CustomButton variant='link' onClick={onClick} className={styles.goToCommentBtn}>
                <Icon src="arrow_vertical" verticalAlign="middle" className={styles.arrow} />
            </CustomButton>}
        </div>
    </div>
}

export default HoverPlayerContent;